<template>
  <div class="container">
    <div>
      <el-tabs v-model="activeName" :before-leave="tabChange">
        <el-tab-pane label="在读学员" name="studying">
          <studyIng :visible="activeName === 'studying'" />
        </el-tab-pane>
        <el-tab-pane label="历史学员" name="history">
          <history :visible="activeName === 'history'" />
        </el-tab-pane>
        <el-tab-pane label="购课档案" name="purchase">
          <purChase :visible="activeName === 'purchase'" />
        </el-tab-pane>
        <el-tab-pane label="结课记录" name="closing">
          <closing :visible="activeName === 'closing'" v-if="showClosing" />
        </el-tab-pane>
        <el-tab-pane label="结业记录" name="graduation">
          <graduation :visible="activeName === 'graduation'" />
        </el-tab-pane>
        <el-tab-pane label="生日学员" name="birthday">
          <birthday :visible="activeName === 'birthday'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import studyIng from "../studying/index.vue";
import purChase from "../purchase/index.vue";
import history from "../history/index.vue";
import closing from "../closingRecord/index.vue";
import graduation from "../graduationRecord/index.vue";
import birthday from "../birthday/index.vue";
import { PageModule } from "@/store/module/page";
import { staffCheckApi } from "@/api/makeUpLessons";

export default {
  name: "studentManage",
  components: { studyIng, purChase, history, closing, graduation, birthday },
  data() {
    return {
      activeName: "studying",
      showClosing: false,
    };
  },
  created() {
    staffCheckApi({
      api_path: ["/api/v1/student/course/completion_list"],
    }).then((res) => {
      if (res.error_code === 0) {
        this.showClosing = res.data["/api/v1/student/course/completion_list"]
          ? true
          : false;
      }
    });
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      this.activeName = this.$route.params.tab || "studying";
    } else {
      const cache = PageModule.pageInfo.studyingList;
      if (cache.tab) {
        this.activeName = cache.tab;
      } else {
        this.activeName = "studying";
        PageModule.SET_PAGE_INFO({
          name: "studyingList",
          key: "tab",
          value: "studying",
        });
      }
    }
    // 来自续费数据页面
    if (this.$route.query.from === "renewal") {
      this.activeName = "closing";
    }
    if (this.$route.query.to === "studentBirthday") {
      this.activeName = "birthday";
    }
  },
  methods: {
    tabChange(n) {
      if (n === "closing") {
        if (!this.showClosing) {
          this.$message({
            type: "warning",
            message: "当前角色无查看权限",
          });
          return false;
        }
      }
      PageModule.SET_PAGE_INFO({
        name: "studyingList",
        key: "tab",
        value: n,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  background: #fff;
}
.el-tabs__item.is-top.is-active {
  color: #07d1aa !important;
}
</style>
